import React from 'react';

import classes from 'components/Settings/Components/RolesManagement/components/addRole.module.scss';
import { AssociatedInput } from 'components/Settings/Components/RolesManagement/components/associatedInput';
import { AssociatedUserInput } from 'components/Settings/Components/RolesManagement/components/associatedUserInput';
import { CheckAll } from 'components/Settings/Components/RolesManagement/components/checkAll';
import { ICheckBoxInputs } from 'components/Settings/Components/RolesManagement/rolesManagment.utils.type';

export const CheckBoxInputs = ({ currentUsers, control, fields, watchFieldArray, replace }: ICheckBoxInputs) => {
    return (
        <div className={classes.multiChoiceContainer}>
            <div className={`${classes.addRoleMultiCheckbox} ${classes.associatedPermission}`}>
                <div className={classes.checkboxesTitles}>
                    <span>Associate Privilege Permissions*</span>
                    <span>
                        <CheckAll
                            replace={replace}
                            watchFieldArray={watchFieldArray}
                            id={'selectAllAssociatePrivilege'}
                        />
                    </span>
                </div>
                <div className={classes.choicesContainer}>
                    <AssociatedInput control={control} fields={fields} />
                </div>
            </div>
            <div className={`${classes.addRoleMultiCheckbox} ${classes.associatedUsers}`}>
                <div className={classes.checkboxesTitles}>
                    <span>Associated Users</span>
                </div>
                <div className={classes.choicesContainer}>
                    <AssociatedUserInput currentUsers={currentUsers} />
                </div>
            </div>
        </div>
    );
};
